import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IContentSection } from '../../../../shared/interfaces/card-info.interface';
import { RevealDirective } from '../../../../shared/directives/reveal.directive';

interface IDevCard {
  /** App-icon graphic under public/images/landing/dev-icons/. */
  icon: string;
  /** Pill label (rendered lowercase to match the design). */
  label: string;
  /** Optional router destination — omit for a non-clickable display card. */
  link?: string;
}

const DEFAULT_CARDS: IDevCard[] = [
  { icon: 'ios-app-v2.png',      label: 'ios app',         link: '/app-development-company' },
  { icon: 'android-app-v2.png',  label: 'android app',     link: '/app-development-company' },
  { icon: 'react-native.png',    label: 'react native',    link: '/app-development-company' },
  { icon: 'ai-app.png',          label: 'ai app',          link: '/ai-app-development-company' },
  { icon: 'saas.png',            label: 'saas',            link: '/app-development-company' },
  { icon: 'web-application.png', label: 'web application', link: '/app-development-company' },
  { icon: 'ux-ui-design.png',    label: 'ux/ui design',    link: '/app-development-company' },
  { icon: 'api-development.png', label: 'api development', link: '/app-development-company' },
];

@Component({
  selector: 'app-dev-services',
  imports: [RouterLink, RevealDirective],
  templateUrl: './dev-services.html',
  styleUrl: './dev-services.scss'
})
export class DevServices {
  /** Supplies heading + lead copy (kept in landing-sections.ts so copy never drifts). */
  @Input({ required: true }) section!: IContentSection;

  /** Optional destination for the section heading (links to the matching service page). */
  @Input() link?: string;

  /** Icon grid — defaults to the home "custom mobile app development" set; override per page. */
  @Input() cards: IDevCard[] = DEFAULT_CARDS;

  /** Lead paragraphs minus the eyebrow line (the short lead that ends with a colon). */
  get bodyLead(): string[] {
    return (this.section.lead ?? []).filter((p) => !/:\s*$/.test(p.trim()));
  }

  /** Eyebrow above the grid — the data's colon-terminated lead line, or a sensible default. */
  get eyebrow(): string {
    return (this.section.lead ?? []).find((p) => /:\s*$/.test(p.trim())) ?? 'services include:';
  }
}
